/**
 * Coming up on the signed-in home (web-account-pages, signed-in-home.html Band 4
 * Stacked): the next three bookings after the next session, a row each with the
 * date, the service, when, where and its status, then how many are booked in
 * all and View all bookings.
 */
import { definePiece } from '../../contract/define';

export const contract = definePiece({
  name: 'coming-up',
  description: "The client's next bookings after the next session, a row each, and View all bookings.",
  placeable: true,
  options: {
    limit: { type: 'number', min: 1, max: 10, default: 3, description: 'How many bookings to list after the next session.' },
  },
  parts: {
    section: { description: 'The whole Coming up.', required: false },
    heading: { description: 'Coming up.', required: false },
    booking: { description: 'One booking: its date, service, when, where and status.', required: false },
    view: { description: "View: the booking's page.", required: true },
    total: { description: 'How many bookings are upcoming in all.', required: false },
    viewAll: { description: 'View all bookings: the Bookings page.', required: false },
  },
  actions: {
    open: { description: "Opens a page of the site (a booking's page, Bookings).", args: [{ name: 'href', kind: 'value', type: 'string', format: 'path' }] },
  },
  events: {},
});

/** One booking in Coming up. */
export interface ComingUpBooking {
  /** The booking's id. */
  readonly id: string;
  /** "Oct". */
  readonly month: string;
  /** "24". */
  readonly day: string;
  /** "October 24", the date read aloud. */
  readonly dateLabel: string;
  /** The service's name. */
  readonly name: string;
  /** "Sat, 2:00 PM · 120 min". */
  readonly when: string;
  /** "Online" or the place's name. */
  readonly where: string;
  /** Confirmed, Pending approval, Payment due. */
  readonly status: string;
  /** The booking's page. */
  readonly href: string;
}

/** What Coming up knows. */
export interface ComingUpState {
  /** The bookings after the next session; empty leaves the section out. */
  readonly bookings: readonly ComingUpBooking[];
  /** "5 upcoming bookings in all." */
  readonly total: string;
  /** The Bookings page. */
  readonly allHref: string;
}

/** What a drawing can ask Coming up to do. */
export interface ComingUpActions {
  /** Open a page of the site. */
  readonly open: (href: string) => void;
}

/** Coming up tells its host nothing. */
export type ComingUpEvents = Record<string, never>;
